// extracted by mini-css-extract-plugin
export var card = "_b8-1";
export var container = "_b8-0";